import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  let { user } = useAuth();
  return user ? <Outlet /> : <Navigate to={routes.LOGIN} />;
};
export default PrivateRoute;
